import { useParams } from 'react-router-dom';

import ContactDetail, { Sidebar } from 'pages/ContactDetail';

import PageLayout from '../components/PageLayout';

const ContactDetailPage = () => {
	const { contactId } = useParams();

	return (
		<PageLayout aside={<Sidebar />}>
			<div className="Page-main">
				<ContactDetail contactId={contactId} />
			</div>
		</PageLayout>
	);
};

export default ContactDetailPage;
